module.exports = __webpack_public_path__ + "img/project2_medium.26aa3e23.webp";